<template>
  <div class="admin-content">
    <div class="content-main">
      <div class="main-header">
        <div class="header-title">
          <span>PRODUCT EDIT</span>
        </div>
        <div class="header-sub-title">
          <span>{{ product.general.name }}</span>
        </div>
      </div>
      <div class="" v-loading="loadingGet">
        <el-tabs tab-position="left" v-model="tabName" :before-leave="changeTab">
          <el-tab-pane label="General" name="General">
            <TabGeneral role="admin" :tab="needSaveTab" :tabUpdate="updateCurrentTab" :actionItem="product" @changeSaveTab="changeSaveTab" />
          </el-tab-pane>
          <el-tab-pane label="Price" name="Price">
            <TabPrice role="admin" :tab="needSaveTab" :tabUpdate="updateCurrentTab" :actionItem="product" @changeSaveTab="changeSaveTab" />
          </el-tab-pane>
          <el-tab-pane label="Images" name="Images">
            <TabImages role="admin" :tab="needSaveTab" :tabUpdate="updateCurrentTab" :actionItem="product" @changeSaveTab="changeSaveTab" />
          </el-tab-pane>
          <el-tab-pane label="Audio" name="Audio">
            <TabAudio role="admin" :tab="needSaveTab" :tabUpdate="updateCurrentTab" :actionItem="product" @changeSaveTab="changeSaveTab" />
          </el-tab-pane>
          <el-tab-pane label="Listening Guide" name="Listening Guide">
            <TabListeningGuide role="admin" :tab="needSaveTab" :tabUpdate="updateCurrentTab" :actionItem="product" @changeSaveTab="changeSaveTab" />
          </el-tab-pane>
          <el-tab-pane label="Discography" name="Discography">
            <TabDiscography role="admin" :tab="needSaveTab" :tabUpdate="updateCurrentTab" :actionItem="product" @changeSaveTab="changeSaveTab" />
          </el-tab-pane>
          <el-tab-pane label="Tech Specs" name="Tech Specs">
            <TabTechSpecs role="admin" :tab="needSaveTab" :tabUpdate="updateCurrentTab" :actionItem="product" @changeSaveTab="changeSaveTab" />
          </el-tab-pane>
          <el-tab-pane label="Frequency Graph" name="Frequency Graph">
            <TabFrequency role="admin" :tab="needSaveTab" :tabUpdate="updateCurrentTab" :actionItem="product" @changeSaveTab="changeSaveTab" />
          </el-tab-pane>
        </el-tabs>
      </div>
      <el-dialog custom-class="dialog-tab" v-model="flagDialogTab" width="30%" :before-close="doTabChange" :show-close="false">
        <div class="title">Save changes before moving on?</div>
        <template #footer>
          <span class="dialog-footer">
            <el-button class="el-btn-blue" @click="saveCurrentTab">SAVE CHANGES</el-button>
            <el-button @click="doTabChange">CANCEL</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import TabGeneral from '@/components/products/TabGeneral'
import TabPrice from '@/components/products/TabPrice'
import TabImages from '@/components/products/TabImages'
import TabAudio from '@/components/products/TabAudio'
import TabListeningGuide from '@/components/products/TabListeningGuide'
import TabDiscography from '@/components/products/TabDiscography'
import TabTechSpecs from '@/components/products/TabTechSpecs'
import TabFrequency from '@/components/products/TabFrequency'
export default {
  name: 'AdminProductEdit',
  components: {
    TabGeneral,
    TabPrice,
    TabImages,
    TabAudio,
    TabListeningGuide,
    TabDiscography,
    TabTechSpecs,
    TabFrequency
  },
  data () {
    return {
      productId: this.$route.params.id,
      product: { general: {} },
      tabName: 'General',
      tabNew: 'General',
      needSaveTab: '',
      updateCurrentTab: false,
      flagDialogTab: false,
      loadingGet: false
    }
  },
  created () {
    this.getProduct()
  },
  mounted () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getProduct: function () {
      if (this.loadingGet) return
      this.loadingGet = true
      const url = `/api/v1/atk_player/admin/products/${this.productId}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.product = res.data
        } else {
          console.error('getProduct', res.msg)
        }
        that.loadingGet = false
      }).catch(function (err) {
        console.error('getProduct', err.msg)
        that.loadingGet = false
      })
    },
    changeTab: function (tabNew, tabOld) {
      this.tabNew = tabNew
      if (!this.needSaveTab) {
        return true
      } else {
        this.flagDialogTab = true
        return false
      }
    },
    saveCurrentTab: function () {
      this.updateCurrentTab = true
    },
    doTabChange: function () {
      this.flagDialogTab = false
      this.tabName = this.tabNew
      this.needSaveTab = ''
      this.updateCurrentTab = false
    },
    changeSaveTab: function (tabName) {
      if (tabName) {
        this.needSaveTab = tabName
      } else {
        this.doTabChange()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.dialog-tab {
  .title {
    text-align: center;
    font-weight: 700;
    font-size: 18px;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
  }
}
</style>
